import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/administracao`

    const headers = { responseType: "arraybuffer" }

    return {
        relatorioHistoricoPapelLotacao(queryParms) {
            return repository.get(`${baseUrl}/relatorio-historico-papel-lotacao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioHistoricoPermissaoLotacao(queryParms) {
            return repository.get(`${baseUrl}/relatorio-historico-permissao-lotacao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioHistoricoPermissaoPapel(queryParms) {
            return repository.get(`${baseUrl}/relatorio-historico-permissao-papel?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioAcessoFuncionalidade(queryParms) {
            return repository.get(`${baseUrl}/relatorio-acesso-funcionalidade?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioAcessoSistema(queryParms) {
            return repository.get(`${baseUrl}/relatorio-acesso-sistema?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioPermissaoLotacao(params) {
            return repository.post(`${baseUrl}/relatorio-permissao-lotacao`, params, headers)
        },
        relatorioPermissaoPapel(params) {
            return repository.post(`${baseUrl}/relatorio-permissao-papel`, params, headers)
        },
        relatorioPapelLotacao(params) {
            return repository.post(`${baseUrl}/relatorio-papel-lotacao`, params, headers)
        },
    }
}
